import React from 'react';
import style from './style.scss';
import Logo from '../logo';
import Input from '../email-input';
import AppStore from '../app-store-badge';

export default () => (
  <div className="home">
    <div className="overlay">
      <div className="homeContainer">
        <Logo/>
        <div>
          <h1 className="homeTitle">KRATOS</h1>
          <p className="homeSlogan">A window into your democracy</p>
        </div>
        <AppStore/>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/home/index.js